import { render } from "./CardHeader.ce.vue?vue&type=template&id=5df16966"
import script from "./CardHeader.ce.vue?vue&type=script&lang=js"
export * from "./CardHeader.ce.vue?vue&type=script&lang=js"

import exportComponent from "/builds/govbr-ds/wbc/govbr-ds-wbc/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__